import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { css } from "@emotion/core"
import MoonLoader from "react-spinners/MoonLoader"
import accountThumbnail from '../../../../../img/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import { requestDeleteUserImage, requestUpdateUserImage } from '../../../../../redux/actions/user'

import './style.scss'

const override = css`
border-color: #5d78ff;
margin: auto;
position: absolute;
top: 0; left: 0; bottom: 0; right: 0;
`;


const Index = () => {

	const dispatch = useDispatch()

	const nameLoading = useSelector(state => state.user.fetchName.loading)
	const authLoading = useSelector(state => state.user.fetchUserDetails.loading)

	const userInfo = useSelector(state => state.user.details)

	const uploadLoading = useSelector(state => state.user.updateImage.loading)
	const deleteLoading = useSelector(state => state.user.deleteImage.loading)
	const thumbnailLoading = useSelector(state => state.user.fetchThumbnail.loading)

	const clickEditImage = () => {
		document.getElementById("selectThumbnail").click()
	}

	const handleImageChange = e => {
		e.preventDefault()

		let file = e.target.files[0]

		if(file){
			dispatch(requestUpdateUserImage({id: userInfo.id, image: file}))
		}
	}

	const clickDeleteImage = () => {
		dispatch(requestDeleteUserImage(userInfo.id))
	}

	

	return(
		<Row className="account-left-upper-row">
			<Col className="account-thumbnail-col">
				<div className="profile-thumbnail-container">
					<img alt={`${userInfo && userInfo.firstName} ${userInfo && userInfo.lastName}`} className="account-thumbnail" src={userInfo && userInfo.thumbnail ? userInfo.thumbnail:accountThumbnail}/>
					{userInfo && userInfo && userInfo.thumbnail && <button onClick={clickDeleteImage} className="remove-image-button"><i className="fas fa-trash-alt"></i></button>}
					<div className="loader-container" style={{opacity: authLoading || uploadLoading || thumbnailLoading || deleteLoading ? '0.7':'0'}}>
                    	<MoonLoader size={30} css={override} className="loader"/>
                    </div>
					<input type="file" id="selectThumbnail" onChange={handleImageChange} className="thumbnail-submitter"/>
				</div>
			</Col>
			<Col className="account-information-col">
				<h1 className="account-name">{authLoading || nameLoading && <i className="fas fa-circle-notch fa-spin"></i>} {authLoading || nameLoading && "Laster inn"} {!nameLoading && userInfo && userInfo.firstName} {!nameLoading && userInfo && userInfo.lastName}</h1>
				<p className="account-company">{authLoading && "Laster inn"} {`Tilknyttet ${userInfo && userInfo.companies && userInfo.companies.length} selskap${userInfo && userInfo.companies && userInfo.companies.length === 1 ? '':'er'}`}</p>
				<button onClick={clickEditImage} className="change-image-button"><i className="fas fa-camera"></i>&nbsp;&nbsp;Endre bilde</button>
			</Col>
		</Row>
	)
}

export default Index
